import { render, staticRenderFns } from "./UserResourse.vue?vue&type=template&id=7d3a5193&"
import script from "./UserResourse.vue?vue&type=script&lang=js&"
export * from "./UserResourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports